import React from 'react';
import StepsML from './StepsML';

export default (props) => <StepsML {...props} />;
